<template>
  <div>
    <toggle-details :defaultOpen="defaultOpen">
      <template slot="header">{{energyType}}</template>
      <template slot="content">
        <p>{{energyItemPriceDetails.Intro}}</p>
        <h6 class="u-font-style--italic default-font-size">
          Leveringskosten
          {{supplierName}}
        </h6>
        <div
          class="u-text-color-grey mb-- small"
        >Laatste prijswijziging: {{energyItemPriceDetails.LastPriceChangeDate}}</div>
        <div
          class="u-text-color-grey mb"
        >De kosten voor het leveren van energie door {{supplierName}}.</div>

        <template v-for="(data,index) in energyItemPriceDetails.DeliveryCosts">
          <tariff-total-row :data="data" :key="index"></tariff-total-row>
        </template>
        <div
          class="u-text-color-grey small mb"
        >Maximale leveringsgrens van dit product is {{energyItemPriceDetails.MaximumDeliveryLimit}}.</div>
        <h6 class="u-font-style--italic default-font-size">Leveringskosten overheid</h6>
        <div
          class="u-text-color-grey mb"
        >Kosten bepaald door de overheid en (bij hetzelfde verbruik) per energieleverancier gelijk.</div>
        <template v-for="(data) in energyItemPriceDetails.DeliveryCostsGovernment">
          <tariff-total-row :data="data" :key="data.Title"></tariff-total-row>
        </template>
        <h6 class="u-font-style--italic default-font-size">Netbeheerkosten {{networkAdministrator}}</h6>
        <div
          class="u-text-color-grey mb"
          v-if="energyItemPriceDetails.NetCostsIntro"
          v-html="energyItemPriceDetails.NetCostsIntro"
        ></div>
        <template v-for="c in energyItemPriceDetails.NetCosts">
          <key-value-label :data="c" :key="c.Title"></key-value-label>
        </template>
        <key-value-label :is-semi-total="true" :data="energyItemPriceDetails.TotalNetCosts"></key-value-label>
        <key-value-label :is-total="true" :data="energyItemPriceDetails.TotalYearCosts"></key-value-label>
        <key-value-label :data="energyItemPriceDetails.TotalExpensesMonth"></key-value-label>
  
      </template>
    </toggle-details>
  </div>
</template>

<script>
import TariffTotalRow from './TariffTotalRow';
import ToggleDetails from './ToggleDetails';
import KeyValueLabel from './KeyValueLabel';
export default {
	props: [
    'resultItem',
		'energyItemPriceDetails',
		'supplierName',
		'networkAdministrator',
		'energyType',
		'defaultOpen'
	],

	components: { KeyValueLabel, TariffTotalRow, ToggleDetails },
	computed: {
		priceDetail: function() {
			return this.resultItem.PriceDetail;
		}
	}
};
</script>
